import React, { useCallback, useState } from "react";
import Modal from "../../Common/Modal";
import EventLogUtil from "../../../Utility/EventLogUtil";
import MtiButton from "../../Buttons/MtiButton";
import VerticalStackedBarChart from "./VerticalStackedBarChart";
import { EventLog } from "../../../Model/EventLog";
import CommonDropDown from "../../Common/DropDown/CommonDropDown";

type Props = {
  eventLogs: EventLog[];
  showChart: boolean;
  setShowChart: (show: boolean) => void;
};

export default function EventLogChart({
  eventLogs,
  showChart,
  setShowChart,
}: Props) {
  const groupBySelection = ["plateTypeName", "userName", "group"];
  const [groupBy, setGroupBy] = useState(groupBySelection[0]);
  const title = "USAGE CHART";
  const subTitle = `(Group By ${EventLogUtil.toName(groupBy)})`;
  const xAxisLabel = EventLogUtil.toName(groupBy);
  const yAxisLabel = "Duration in Hours";
  const [onClickSave, setOnClickSave] = useState({ onSave: () => {} });

  const groupByDisplayValues = groupBySelection.map((selection) => ({
    display: EventLogUtil.toName(selection),
    value: selection,
    disabled: false,
  }));

  const onChangeGroupBy = useCallback((groupBy) => {
    setGroupBy(groupBy);
  }, []);

  const groupBySelector = (
    <div className="modal-selector">
      <label>Group By</label>
      <label>:</label>
      <CommonDropDown
        id="eventLog-chart-groupby-select"
        dropDownDisplayValues={groupByDisplayValues}
        style={{
          width: 125,
          height: 32,
          fontSize: 13.3
        }}
        onChange={(value) => onChangeGroupBy(value)}
        value={groupBy}
      />
    </div>
  );

  return (
    <Modal
      show={showChart}
      onHide={() => setShowChart(false)}
      className="modal-event-log-chart"
    >
      <Modal.Header
        title="Chart"
        hideButtonEnabled={true}
        className="modal-header"
      />

      <Modal.Body>
        {groupBySelector}
        <VerticalStackedBarChart
          title={[title, subTitle]}
          groupBy={groupBy}
          data={eventLogs}
          xAxisLabel={xAxisLabel}
          yAxisLabel={yAxisLabel}
          width={1370}
          height={574}
          setOnClickSave={setOnClickSave}
        />
      </Modal.Body>

      <Modal.Footer className="modal-footer">
        <MtiButton
          size="large"
          onClick={onClickSave.onSave}
          style={{
            width: 170,
            height: 48,
            float: "right",
          }}
        >
          SAVE CHART
        </MtiButton>
      </Modal.Footer>
    </Modal>
  );
}
